"use client";
import Image from "next/image";
import React from "react";
import CareerGuidanceForm from "./CareerGuidanceForm";

const CareerGuidance: React.FC = () => {
  return (
    <section className="w-full bg-[#C7F8FF]/30 text-black pt-12.5 pb-14.25 px-4 relative">
      <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 -translate-x-1/2 -top-5">
        <Image
          src="/assets/small-logo.svg"
          alt="small-logo"
          title="small-logo"
          width={30}
          height={17}
        />
      </div>

      <h2 className="mb-8 md:mb-9.25 text-center text-[#1B365E] text-[28px] md:text-[58px] leading-9.25 md:leading-19.25 font-semibold font-red-hat tracking-[0.05rem]">
        Nous sommes là pour bien vous orienter
      </h2>

      <div className="max-w-258.25 w-full mx-auto flex md:flex-row flex-col items-start text-left justify-between gap-8 md:gap-6">
        <div className="max-w-116.75 w-full md:text-left text-center">
          <h3 className="text-[#1B365E] text-[15px] md:text-[20px] leading-4.5 md:leading-7.5 tracking-[0.01rem] font-bold md:font-normal">
            Quelques questions suffisent pour vous adresser un{" "}
            <span className="font-bold">devis précis</span>, adapté à vos objectifs et à votre budget.
          </h3>
          <ul className="mt-8 md:mt-11 flex items-start justify-center flex-col mx-auto w-full space-y-5.75">
            <li className="flex items-center gap-3.25">
              <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#40BFDE]"></div>
              <p className="text-[#1B365E] text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">
                Analyse de votre besoin :  <span className="font-normal">objectifs, niveau et nombre de participants</span>
              </p>
            </li>
            <li className="flex items-center gap-3.25">
              <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#40BFDE]"></div>
              <p className="text-[#1B365E] text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">
                Choix du format : <span className="font-normal">inter, intra ou sur-mesure, présentiel ou distanciel</span>
              </p>
            </li>
            <li className="flex items-center gap-3.25">
              <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#40BFDE]"></div>
              <p className="text-[#1B365E] text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">
               Étude des financements : <span className="font-normal">OPCO, plan de développement des compétences…</span>
              </p>
            </li>
            <li className="flex items-center gap-3.25">
              <div className="sm:w-5.25 h-4 w-4 sm:h-5.25 rounded-full bg-[#40BFDE]"></div>
              <p className="text-[#1B365E] text-[12px] sm:text-[16px] leading-3.5 sm:leading-6.5 tracking-[0.01rem] font-bold">
                Proposition chiffrée : <span className="font-normal">un devis détaillé, sans engagement</span>
              </p>
            </li>
          </ul>
        </div>

        <div className="max-w-116.75 w-full">
          <CareerGuidanceForm />
        </div>
      </div>
    </section>
  );
};

export default CareerGuidance;
